export { sharedCookieDomain as cookieDomain } from '@/platform/config/domainPolicy'

export function safeReturnPath(value: string | null | undefined, origin: string): string {
  try {
    const target = new URL(value || '/', origin)
    if (target.origin !== origin || target.pathname === '/auth/callback') return '/'
    return `${target.pathname}${target.search}${target.hash}`
  } catch {
    return '/'
  }
}
